/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Admin_OnlyInputs */

const en_ai_admin_only = /** @type {(inputs: Ai_Admin_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only the admin can change these settings.`)
};

const de_ai_admin_only = /** @type {(inputs: Ai_Admin_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur der Admin kann diese Einstellungen ändern.`)
};

/**
* | output |
* | --- |
* | "Only the admin can change these settings." |
*
* @param {Ai_Admin_OnlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_admin_only = /** @type {((inputs?: Ai_Admin_OnlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Admin_OnlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_admin_only(inputs)
	return en_ai_admin_only(inputs)
});